import { Box, CircularProgress, Typography } from "@mui/material";

interface CountdownTimerProps {
  timeRemaining: number;
  maxTime: number;
}

export const CountdownTimer = ({
  timeRemaining,
  maxTime,
}: CountdownTimerProps) => {
  const value = 100 / maxTime;
  return (
    <Box
      sx={{
        position: "relative",
        display: "inline-flex",
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      <CircularProgress variant="determinate" value={timeRemaining * value} />
      <Box
        sx={{
          top: 0,
          left: 0,
          bottom: 0,
          right: 0,
          position: "absolute",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <Typography
          variant="caption"
          component="div"
          color="text.secondary"
        >{`${timeRemaining}`}</Typography>
      </Box>
    </Box>
  );
};
